import { render, staticRenderFns } from "./DatatableEditDialog.vue?vue&type=template&id=060b275b&"
import script from "./DatatableEditDialogScript.js?vue&type=script&lang=js&"
export * from "./DatatableEditDialogScript.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports